














































































































import Vue from 'vue';
import Pagination from '@/components/Base/Pagination.vue'

export default Vue.extend({
  name: 'AdminUser',
  data() {
    return {
      activePage: 1,
      itemsPerPage: 30,
      filter: ""
    }
  },
  components: {
        Pagination
  },
  created() {
    this.$store.dispatch('clearFilters');
    this.$store.dispatch('loadUnternehmen');
  },
  methods: {
    setActivePage(value: number): void {
      this.activePage = value;
    }
  },
  computed: {
    unternehmenfiltered: function() {
      if(this.filter == ""){
        return this.$store.state.unternehmen;
      } else {
        return this.$store.state.unternehmen.filter((item) => item.firma.toLowerCase().includes(this.filter.toLowerCase()));
      }

    },
    unternehmenpaged: function(): Array<any> {
      return this.unternehmenfiltered.slice((this.activePage-1) * this.itemsPerPage, this.activePage * this.itemsPerPage);
    },
    paged: function(): boolean{
      return this.unternehmenfiltered.length > this.itemsPerPage;
    },
    pages: function(): number {
      return Math.ceil(this.unternehmenfiltered.length / this.itemsPerPage);
    },
  }
});
